import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { CountryList, Country } from '../../models/countries';
import { ApiService } from '../../services/api.service';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { format } from 'date-fns';
import { NamedId } from '../../models/NamedId';
import { ReferenceDataService } from 'src/app/services/reference-data.service';


@Component({
  selector: 'app-request-seed-treatment',
  templateUrl: './request-seed-treatment.component.html'
})
export class RequestSeedTreatmentComponent implements OnInit {
  @ViewChild('formedEmail', { read: ElementRef }) formedEmail: ElementRef;
  yaraProductChoices: NamedId[] = [];
  seedCoatingRequestForm: | UntypedFormGroup;
  applicationUnitChoices: string[] = ['Litres', 'Millilitres', 'Kilogrammes', 'Grammes'];
  countryChoices: Country[] = CountryList;
  invalidIngredients: boolean = false;
  
  constructor(private api: ApiService, 
    private fb: UntypedFormBuilder,
    private refData: ReferenceDataService,
    private router: Router) { }

  ngOnInit() {
    var today=new Date();
    this.seedCoatingRequestForm = this.fb.group({
      kind:['seed'],
      name: [null, Validators.required],
      email: [null, [Validators.required, Validators.email]],
      company: [null],
      country: [null, Validators.required],
      requestDate: [format(today,'yyyy-MM-dd'), Validators.required],
      waterRate: [null],
      seedName: [null],
      comments: [null],
      ndaRef: [null],
      ingredients: this.fb.array([])
    });
    this.addProduct();
  }
  get name() { return this.seedCoatingRequestForm.get('name'); }
  get email() { return this.seedCoatingRequestForm.get('email'); }
  get company() { return this.seedCoatingRequestForm.get('company'); }
  get waterRate() { return this.seedCoatingRequestForm.get('waterRate'); }
  get requestDate() { return this.seedCoatingRequestForm.get('requestDate'); }
  get country() { return this.seedCoatingRequestForm.get('country'); }
  get ndaRef() { return this.seedCoatingRequestForm.get('ndaRef'); }

  get formValues():any{
    return this.seedCoatingRequestForm.value;
  }
  get ingredients(): UntypedFormArray {
    return this.seedCoatingRequestForm.get('ingredients') as UntypedFormArray;
  }
  addProduct() {
    console.log('Adding product');
    this.ingredients.push(this.fb.group(
      {
        name: [null,Validators.required],
        orderOfAddition: [this.ingredients.length + 1],
        applicationRate: [null,Validators.required],
        applicationUnit: ['',Validators.required]
      }
    ));
  }
  deleteProduct(index) {
    this.ingredients.removeAt(index);
  }
  submitRequest() {

    if (this.seedCoatingRequestForm.valid) {

      if (!this.areIngredientsInvalid()) {
       
        const html = document.getElementById('formedEmail').innerHTML;
        let request=this.seedCoatingRequestForm.value;
        request.comments=[{comment:request.comments}];
        this.api.submitRequest(request, html).subscribe(data =>
          {
            this.router.navigateByUrl('request-submitted');
          }
        );
       
      }
      else {
        console.log('no ingredients data - Invalid submission')
      }

    }
    
  }

  areIngredientsInvalid() {
    
    console.log('si');
    var result = (this.ingredients.controls.some(x => x.get('name').value === null || x.get('name').value === '')
    ||  this.ingredients.controls.some(x => x.get('applicationRate').value === null || x.get('applicationRate').value === ''));    
    console.log(result);
    this.invalidIngredients = result;
    return  result;
  }

  countryChanged() {
 
    this.api.getYaraProducts(this.formValues.country).subscribe(x => {
      this.yaraProductChoices = x
    })
    
  }

}
